import { useCallback, useEffect, useRef } from 'react'

import { QUERY_REFETCH_INTERVAL } from 'consts/query/query'

export const useIntervalWhileFocused = (callback: () => void) => {
  const intervalRef = useRef<number | null>(null)

  const startInterval = useCallback(() => {
    if (!intervalRef.current) {
      intervalRef.current = window.setInterval(() => {
        callback()
      }, QUERY_REFETCH_INTERVAL)
    }
  }, [callback])

  const stopInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }

  const resetInterval = () => {
    stopInterval()
    startInterval()
  }

  useEffect(() => {
    const handleFocus = () => {
      callback()
      startInterval()
    }

    const handleBlur = () => {
      stopInterval()
    }

    window.addEventListener('focus', handleFocus)
    window.addEventListener('blur', handleBlur)

    return () => {
      window.removeEventListener('focus', handleFocus)
      window.removeEventListener('blur', handleBlur)
    }
  }, [callback, startInterval])

  useEffect(() => {
    startInterval()

    return () => {
      stopInterval()
    }
  }, [startInterval])

  return {
    resetInterval,
  }
}
